import { render, staticRenderFns } from "./PayByCardReturn.vue?vue&type=template&id=4d924334"
import script from "./PayByCardReturn.vue?vue&type=script&lang=js"
export * from "./PayByCardReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports